// extracted by mini-css-extract-plugin
export default {"continueShopping":"ContinueShopping_continueShopping__-8p+h","continueShoppingText":"ContinueShopping_continueShoppingText__7MJzE"};